<template>
  <div>
    <div class="box no-padding">
      <div class="header">Service Rate Settings</div>
      <div class="body">
        <table v-if="!isMobile">
          <thead>
            <th></th>
            <th>Rent Fare</th>
            <th>Hourly Rent Rate</th>
            <th>Daily Rent Rate</th>
            <th>Weekend Rent Rate</th>
          </thead>
          <tbody>
            <tr v-for="(service, index) in services" v-show="showService(service)" :key="index">
              <td>{{ service.name }}</td>
              <td>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service.rental.rentFare" 
                  ></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRate"
                  ></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRateDaily" 
                  ></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRateWeekend" 
                  ></vue-autonumeric>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="cards" v-else>
          <div class="card"  v-for="(service, index) in services" v-show="showService(service)" :key="index">
            <div class="card-header">
              {{ service.name }}
            </div>

            <div class="row-fields">
              <div class="title" v-show="showAirportFee">
                <div class="label">Rent Fare</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service.future.airportFee" 
                  ></vue-autonumeric>
              </div>
              <div class="title">
                <div class="label">Hourly Rent Rate</div>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRate"
                  ></vue-autonumeric>
              </div>
            </div>
            <div class="row-fields">
              <div class="title">
                <div class="label">Daily Rent Rate</div>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRateDaily" 
                  ></vue-autonumeric>
              </div>
              <div class="title">
                <div class="label">Weekend Rent Rate</div>
                <vue-autonumeric :options="dollar6deci" :disabled="saving"
                  v-model="service.rental.rentRateWeekend" 
                  ></vue-autonumeric>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import DatePicker from 'vue2-datepicker'
import Promo from './Promo'
import ApiServices from '@/modules/api/pricing/service-types'

export default {
  name: 'charter-pricing',
  components: { VueAutonumeric, DatePicker, Promo },
  props: ['type', 'isMobile'],
  data () {
    return {
      showAirportFee: false,
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.00',
        decimalPlaces: 2
      },
      dollar6deci: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.000000',
        decimalPlaces: 6
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      error: {
        pickupTypes: ''
      },
    }
  },
  computed: {
    travelInsuranceLabel () { return this.$settings.get('TravelInsuranceLabel') },
    selectedBrand () { return this.$store.state.pricing.brandId },
    selectedServiceArea () { return this.$store.state.pricing.serviceArea.activeId },
    services () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.brandEnabled && x.enabled && x.isRental) },
    discountStart: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let discountStart = serviceArea.charterDiscountStart
        if (!discountStart) { return null }
        return moment(discountStart, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountStart: moment(value).format('YYYY-MM-DD')
        })
      }
    },
    discountEnd: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let discountEnd = serviceArea.charterDiscountEnd
        if (!discountEnd) { return null }
        return moment(discountEnd, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountEnd: moment(value).format('YYYY-MM-DD')
        })
      }
    },
    minDate () { return moment().toDate() },
    discountEndMin () {
      let date = new Date()
      if (this.discountStart) {
        date = this.discountStart
      }
      return date
    },
    saving () { return this.$store.state.pricing.saving },
  },
  methods: {
    showService (data) {
      return (this.selectedServiceArea === 0 && data.brandEnabled) || (data.enabled && data.brandEnabled)
    },
    updateValue (index, field) {
      this.$store.commit('pricing/updateServiceTypeField', {
        id: this.services[index].id,
        field: field,
        type: 'future',
        value: this.services[index].future[field]
      })
    },
    removePromo (index) {
      let self = this
      let promo = self.promos.list[index]
      let promos = []
      for (let i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue
        }
        promos.push(self.promos.list[i])
      }
      self.promos.list = promos
      self.$sdk.delete('/geofences/' + self.selectedServiceArea + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log('PROMO REMOVED', r)
      })
    },
    save () {
      let self = this
      if (this.saving) { return }

      self.$store.commit('pricing/setSaving', true)
      ApiServices.setPriceSettings(self, 'rental', res => {
        self.$store.commit('pricing/setSaving', false)
        let response = {
          show: true,
          status: 'success',
          message: 'Successfully updated pricing data!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('response', response)

        let origData = []
        res.list.forEach(service => {
          origData.push({
            id: service.serviceType.id,
            enabled: self.cleanCopy(service.enabled),
            asap: self.cleanCopy(service.asap),
            charter: self.cleanCopy(service.charter),
            flight: self.cleanCopy(service.flight),
            future: self.cleanCopy(service.future),
            pickupTypes: self.cleanCopy(service.pickupTypes),
            rental: self.cleanCopy(service.rental)
          })
        })
        self.$store.commit('pricing/setOriginalData', origData)
      })
    },
    cleanCopy (x) {
      return JSON.parse(JSON.stringify(x))
    },
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.p-R-0 { padding-right: 0; }
.p-L-0 { padding-left: 0; }
.p-L-10 { padding-left: 10px; }
.row{ max-width: 100%; }

.box{
  background: #fff;
  border-radius: 2px;
  border: 1px solid #b0c6e4;
  margin-bottom: 30px;
  box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);

  .header{
    padding: 10px;
    background: #0D79F2;
    text-transform: uppercase;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
  }
  .body{
    .error-msg{
      font-size: 12px;
      color: #fff;
      font-style: italic;
      display: block;
      padding: 5px;
      text-align: center;
      background: #ff4d4d;
    }
  }
}

table{
  background: #fff;
  width: 100%;
  // border: 1px solid rgba(0, 0, 0, 0.15);
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  // border-radius: 3px;
  text-align: left;
  border-spacing: 0;
  text-align: center;

  thead th{
    font-size: 13px;
    font-weight: 100;
    color: #777;
    padding: 10px 0 0;
  }
  tbody{
    td{
      padding: 8px 7px;
      font-size: 14px;

      &:last-child{ padding-bottom: 15px; }
    }
    input{
      max-width: 110px;
      margin: 0;
      display: inline-block;
      text-align: center;
    }
    .small-input { width: 60px; }
    .discount, .roundtrip{
      max-width: 90px;
      min-width: 50px;
    }
    .fa-square, .fa-check-square{ color: #0D79F2; }
    i.disabled {
      opacity: .4;
      cursor: not-allowed;
    }
  }
  .discount{ background: #fafafa; }
  .roundtrip{ background: #f5f5f5; }
}
.discount-date{
  background: #eaf2fb;
  text-align: left;
  border-top: 1px solid #b0c6e4;
  padding: 10px 0;

  &.holiday, &.promo{ text-align: center; }
  .label, .field{ display: inline-block; }
  .label{
    font-size: 14px;
    font-weight: 600;
    color: #3b5573;
    margin-right: 10px;
  }
  .field{ min-width: 150px; }
  .sub-label{
    display: block;
    font-size: 11px;
    color: #888;
    line-height: 1;
    margin: 0 0 3px 2px;
  }
  .table-label{
    text-align: right;
    padding-right: 20px!important;
  }
  .date-input-block{
    display: block;
    width: 100%;
    margin-bottom: 2px;
  }
  .button{ margin-top: 10px; }
}
.holiday-rates{
  select{
    max-width: 60px;
    min-width: 60px;
  }
}

select{
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 43px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}

@media only screen and (max-width: 430px) {
  .p-R-0 { padding-right: 0; }
  .p-L-0 { padding-left: 0; }
  .p-L-10 { padding-left: 0; }

  .discount-date {
    padding: 10px;
    .field {
      width: 100%;
    }
  }
  
  .date-box {
    padding: 0 10px;
  }

  .cards {
    padding-top: 10px;
    .card {
      border: 1px solid #b0c6e4;
      margin: 0 10px;
      margin-bottom: 15px;
      padding-bottom: 3px;
      border-bottom: 5px solid #b0c6e4;
      font-weight: 700;

      > div {
        margin-bottom: 3px;
      }

      .row-fields {
        display: flex;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #eaf2fb;
        padding: 5px 10px;
        font-size: 14px;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 900;
        }
      }

      .title {
        display: flex;
        flex-direction: column;
        padding: 5px 10px;

        input {
          margin: 0;
          padding: 5px 10px;
          font-size: 14px;
        }

        select {
          margin: 0;
          padding: 5px 10px;
          font-size: 14px;
          height: 35px;
          width: 80px;
        }

        .discount {
          display: flex;
          width: 100%;
        }
      }

      .label {
        font-size: 12px;
        color: #666;
        font-weight: 100;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }

    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Pricing/Rental.vue